// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxaut } from "../../../icons/mono/build/icon-axaut.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxautIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxaut.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxautIcon.displayName = 'AxautIcon';
}

export default AxautIcon;